export enum LocalStorageKeys {
  AUTH_TOKEN = 'ma_auth_token',
  USER = 'ma_user',
  SELECTED_CLIENT = 'ma_selected_client',
}
